import { useState, useEffect, useCallback } from 'react';

/**
 * Hook para gerenciar o estado e a lógica da barra de busca.
 * @param {object} initialParams - Os valores iniciais para os filtros.
 * @param {function} onSearch - A função a ser chamada quando uma busca é acionada.
 */
export function useSearchBar(initialParams, onSearch) {
    
    const [formData, setFormData] = useState(initialParams);

    useEffect(() => {
        setFormData(initialParams);
    }, [initialParams]);

    const handleInputChange = useCallback((e) => {
        const { name, value } = e.target;
        setFormData(prevData => ({
            ...prevData,
            [name]: value
        }));
    }, []);

    const handleFilterChange = useCallback((filterName, value) => {
        setFormData(prevData => {
            const newFormData = {
                ...prevData,
                [filterName]: value
            };
            onSearch(newFormData); 
            return newFormData;
        });
    }, [onSearch]);

    const handleSubmit = useCallback((e) => {
        e.preventDefault();
        onSearch(formData);
    }, [onSearch, formData]);

    // 4. Retorna as novas funções
    return {
        formData,
        handleInputChange,
        handleFilterChange,
        handleSubmit
    };
}